import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {Option} from '../../../shared/models/option';
import {URL_PARAM_KEY_PAGE_NUMBER, UrlService} from '../../../core/services/url.service';
import {NgClass} from '@angular/common';

@Component({
  selector: 'motn-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
  ],
})
export class PaginatorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() totalElementQty: number = 0;
  @Input() elementsPerPage: number = 50;
  @Input() pageOptionsQty: number = 10;
  @Input() pageNumber: number = 1;
  @Input() autoScroll: boolean = true;
  @Input() disableUrlUpdate: boolean = false;

  @Output() pageNumberOutput$: EventEmitter<number> = new EventEmitter<number>();

  selectorValue$: BehaviorSubject<number>;
  selectorOptions: Option[] = [];

  pageNumberSub: Subscription;


  constructor(
    private urlService: UrlService,
  ) {
  }


  ngOnInit(): void {
    this.pageNumberSub = this.urlService.pageNumber$.subscribe({
      next: (page) => {
        if (this.disableUrlUpdate) {
          return;
        }

        if (!page) {
          page = 1;
        }

        if (page !== this.pageNumber) {
          this.goToPage(page);
        }
      },
    });

    this.selectorValue$ = new BehaviorSubject<number>(this.pageNumber);
    // this.populatePageOptions();
  }


  ngOnChanges(): void {
    this.populatePageOptions();
  }


  ngOnDestroy() {
    this.pageNumberSub?.unsubscribe();
  }


  populatePageOptions(): void {
    let options: Option[] = [];
    let pageQty: number = this.getPageQty();

    if (pageQty === 0) {
      this.selectorOptions = [];
      return;
    }

    for (let p = 1; p <= pageQty; p++) {
      options.push({
        id: '' + p,
        name: '' + p,
        selected: p === this.pageNumber,
      });
    }

    if (options.length > this.pageOptionsQty) {
      const optionPadding = Math.floor(this.pageOptionsQty / 2);

      if (this.pageNumber < optionPadding) {
        options = options.slice(0, this.pageOptionsQty);
      } else if (this.pageNumber > pageQty - optionPadding) {
        options = options.slice(pageQty - this.pageOptionsQty);
      } else {
        options = options.slice(this.pageNumber - optionPadding, this.pageNumber + optionPadding);
      }

      // if (options[0].name !== '1') {
      //   options[0].name = '← ' + options[0].name;
      // }

      if (options[this.pageOptionsQty - 1].name !== '' + pageQty) {
        options[this.pageOptionsQty - 1].name = options[this.pageOptionsQty - 1].name + '+';
      }
    }

    this.selectorOptions = options;
  }


  getPageQty(): number {
    return Math.ceil(this.totalElementQty / this.elementsPerPage);
  }


  goToPage(page: number): void {
    this.pageNumber = page;
    this.pageNumberOutput$.emit(this.pageNumber);
    if (!this.disableUrlUpdate) {
      this.urlService.setPageNumber(page);
    }
    this.populatePageOptions();

    if (this.autoScroll && !this.disableUrlUpdate) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 0);
    }
  }


  goToPreviousPage(): void {
    if (this.pageNumber > 1) {
      this.goToPage(this.pageNumber - 1);
    }
  }


  goToNextPage(): void {
    if (this.pageNumber < this.getPageQty()) {
      this.goToPage(this.pageNumber + 1);
    }
  }
}
